import React, { createContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { clearAuthAndRedirect, clearStoredAuth, getSessionToken } from '../services/http/auth.js';
import { myCompanyService } from '../services/companies/myCompanyService.js'

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = getSessionToken();

    const loadUser = async () => {
      if (token) {
        try {
          const decoded = jwtDecode(token);

          const currentTime = Date.now() / 1000;
          if (decoded.exp && decoded.exp < currentTime) {
            console.warn('Token expirado. Limpiando sesión...');
            clearStoredAuth();
            setIsLoading(false);
            return;
          }

          let companyName = '';
          try {
            const { company } = await myCompanyService.getMyCompany();
            companyName = company.name;
          } catch (companyError) {
            console.error('Error fetching company:', companyError);
          }

          const userData = {
            id: decoded.id,
            name: decoded.name || decoded.email,
            email: decoded.email,
            role: decoded.role,
            companyName
          };

          setUser(userData);
          setIsAuthenticated(true);
          localStorage.setItem('userData', JSON.stringify(userData));
        } catch (error) {
          console.error('Error decoding token:', error);
          clearStoredAuth();
        }
      }

      setIsLoading(false);
    };

    loadUser();
  }, []);

  const login = (user) => {
    setIsAuthenticated(true);
    setUser(user);
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUser(null);
    clearStoredAuth();
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const getAuthToken = () => {
  return getSessionToken();
};

export const getUserFromToken = () => {
  const token = getAuthToken();
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));

    let companyName = '';
    try {
      const storedUser = JSON.parse(localStorage.getItem('userData'));
      companyName = storedUser?.companyName || '';
    } catch (storageError) {
      console.error('Error reading cached user data:', storageError);
    }

    return {
      id: payload.id,
      email: payload.email,
      role: payload.role,
      name: payload.name || payload.email,
      companyName
    };
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export const setCookie = (name, value, days = 7) => {
  Cookies.set(name, value, {
    expires: days,
    path: '/',
    sameSite: 'Strict',
    secure: window.location.protocol === 'https:'
  });
};

export const clearAuth = () => {
  clearAuthAndRedirect({ ignoreIfAlreadyOnLogin: false });
};

export { AuthProvider, AuthContext };
